<template>
  <section class="loading-grid" role="status" aria-live="polite" :aria-label="label">
    <span class="sr-only">{{ label }}</span>

    <article v-for="cardIndex in cardCount" :key="cardIndex" class="card loading-card">
      <header class="loading-head">
        <div class="skeleton skeleton-title" />
        <div class="skeleton skeleton-meta" />
      </header>

      <div class="loading-rows">
        <div v-for="rowIndex in rowCount" :key="`${cardIndex}-${rowIndex}`" class="loading-row">
          <div class="skeleton skeleton-cell skeleton-cell--wide" />
          <div class="skeleton skeleton-cell" />
          <div class="skeleton skeleton-cell" />
        </div>
      </div>
    </article>
  </section>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    default: 'Loading quick stats data'
  },
  cardCount: {
    type: Number,
    default: 2
  },
  rowCount: {
    type: Number,
    default: 4
  }
})
</script>

<style scoped>
.loading-grid {
  display: grid;
  gap: 1rem;
}

.loading-card {
  padding: 1rem;
  border-color: rgba(207, 207, 199, 0.92);
  background: linear-gradient(180deg, #ffffff, #fbfbf7);
  box-shadow: 0 12px 30px rgba(12, 12, 10, 0.08);
}

.loading-head {
  display: grid;
  gap: 0.5rem;
  margin-bottom: 0.9rem;
}

.loading-rows {
  display: grid;
  gap: 0.45rem;
}

.loading-row {
  display: grid;
  grid-template-columns: minmax(140px, 2fr) minmax(70px, 1fr) minmax(70px, 1fr);
  gap: 0.5rem;
}

.skeleton {
  height: 0.82rem;
  border-radius: 999px;
  background:
    linear-gradient(100deg, rgba(225, 225, 218, 0.95) 15%, rgba(91, 124, 255, 0.2) 42%, rgba(225, 225, 218, 0.95) 68%)
    #eeeeea;
  background-size: 220% 100%;
  box-shadow: inset 0 0 0 1px rgba(207, 207, 199, 0.5);
  animation: quick-stats-shimmer 1.4s ease-in-out infinite;
}

.skeleton-title {
  width: min(220px, 42%);
  height: 1rem;
}

.skeleton-meta {
  width: min(180px, 32%);
}

.skeleton-cell {
  width: 100%;
}

.skeleton-cell--wide {
  width: min(300px, 100%);
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@keyframes quick-stats-shimmer {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
}

@media (max-width: 768px) {
  .loading-row {
    grid-template-columns: 1.5fr 1fr;
  }

  .loading-row .skeleton-cell:last-child {
    display: none;
  }
}
</style>
